/* eslint-disable */
require('build/babelHelpers');
const UrlUtils = require('utils/Url');
const localeUtils = require('utils/LanguageLocale');


//Polyfills
require('whatwg-fetch');
require('core-js/fn/object/assign');
require('core-js/fn/promise');
require('core-js/fn/symbol');
require('performance-polyfill');
require('utils/shims/ObjectValues');

// First file to run when priority.bundle.js has loaded.
// Any pre-initialization code should be placed in here.
require('utils/framework/PriorityLoaded');

// Place all async rendered components in Sephora.Comps.
// Initialize component inflation logic, e.g. ApplyCtrlr & renderQueue
// Require.ensure inPageList.js which will add <script src="compnents.chunk.js"> to the page
require('utils/framework/InflateComponents');
require('utils/framework/InflateSPA');

const { initializeApplication } = require('./utils/framework/initialization');
initializeApplication();

// = Initialize the third-party and internal services = //
// These are listed in order of priority.
// Generally speaking each of these hooks up to any third party JS files needed
// and or requests expected data from the third party service.
// Once that data is returned it should first populate the store with that data
// and then run renderQueue for any async render components prioritized with that service.
require('services/UserInfo');
require('services/LithiumHeaderImage');
require('services/History');
require('services/Search');
require('services/Catalog');
require('services/RefreshBasket');
require('services/Certona')();
require('services/TestTarget')();
require('services/AddStructure')();

// require.ensure is used to package nested requires in components.chunk.js
// rather than priority.bundle.js in order to keep priority.bundle.js lean
require.ensure([], function (require) {
    require('services/Location');
    require('services/OrderInfo');
    require('services/PostLoad');
    require('services/ThirdParty');
}, 'components');
